import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RedefinirSenha } from '@/features/login/page/RedefinirSenha/RedefinirSenha';

export const Route = createFileRoute('/auth/redefinir-senha')({
    component: RedefinirSenha,
    validateSearch: z.object({ encode: z.string().optional() }),
});
